export default __webpack_public_path__ + "static/media/Order_05.583fd402.png";